import connect from '../views/axios/axios.auth';
import jwt_decode from "jwt-decode";
import CryptoJS from 'crypto-js';

const configFunction = {
  config: () => {
    return new Promise( async (resolve) => {
      const session = localStorage.getItem('@session');
      if (session) {

      const auth = JSON.parse(session);
      const unCrypt =  CryptoJS.AES.decrypt(auth.token, 'gkJ5dejNOosNDD5G2QZ');
      const originalToken = unCrypt.toString(CryptoJS.enc.Utf8);
      const authData = jwt_decode(originalToken);
      connect.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
      
      try {
      
        const empresa = await connect.get(`/empresa`);
        const graficos = await connect.post(`/reportes/semana-envios`);
        const operaciones = await connect.get(`/empresa/configuracion-extra`);
        const tiposSalidas = await connect.get(`/guias/tipos`);

        Promise.all([empresa, graficos, operaciones, tiposSalidas]).then( function (values) {
          resolve({
            ...values[0],
            graficos: values[1].data,
            operaciones: values[2].data,
            tipo_user: authData.data.tipo_id,
            user_id: authData.data.id,
            tipo_salidas: values[3].data,
          });
        });

      } catch (e) {
        resolve({ status: 401 });
      }

     } else {
      resolve({ status: 401 });
     } 
    })
  }
}

export default configFunction;